import styled from 'styled-components';

// ------------------------------
// ---- ACTION BUTTON STYLES ----
export const FeatureListContainer = styled.div`
  position: relative;
  padding: 2em 0 4em;
`

export const FeatureListButtonContainer = styled.div`
  display: grid;
  padding-top: 1em;
  row-gap: 2em;
`
